<div class="lpo-dialog-container">
    <div class="lpo-header-actions">
        <h2>Edit Time Sheet Template</h2>
        <div class="spacer"></div>
        <button mat-button (click)="close()">Cancel</button>
        <button mat-raised-button color="primary" (click)="save()">
            <mat-icon>save</mat-icon> Save Template
        </button>
    </div>

    <div class="lpo-scroll-area">
        <div class="lpo-paper">

            <!-- Company/Brand Header -->
            <div class="po-header">
                <div class="logo-section">
                    <div class="company-logo-wrapper">
                        <div class="logo-preview"
                            [style.backgroundImage]="'url(' + (data.logoBase64 || data.logoUrl || '../../../../assets/landingpage/Avatar.png') + ')'">
                            <div class="overlay" (click)="triggerLogoInput()">
                                <mat-icon>camera_alt</mat-icon>
                                <span>Change Logo</span>
                            </div>
                        </div>
                        <input type="file" id="tsLogoInput" (change)="onLogoSelected($event)" accept="image/*" hidden>
                        <div class="logo-info">
                            <h3>Company Logo</h3>
                            <p>Upload a clear PNG or JPG logo.</p>
                        </div>
                    </div>
                </div>
                <!-- <div class="logo-section">
                    <h1 class="brand-name">ALYN<span>360</span></h1>
                    <p class="tagline">Equipment Rental Marketplace</p>
                </div> -->
                <div class="po-title">
                    <h2>TIME SHEET</h2>

                    <!-- <mat-form-field appearance="outline" subscriptSizing="dynamic">
                        <mat-label>Header Text / Subtitle</mat-label>
                        <textarea matInput [(ngModel)]="data.header" rows="2"
                            placeholder="e.g. Time Sheet for [Company Name]"></textarea>
                    </mat-form-field> -->

                    <p style="margin-top: 10px;"><strong>TS Number:</strong> TS-XXXXXX</p>
                    <p><strong>Date:</strong> {{ today | date:'dd MMM yyyy' }}</p>
                </div>
            </div>

            <div class="address-section">
                <!-- VENDOR (User) Details - Editable -->
                <div class="address-block editable-block">
                    <h3>Vendor</h3>

                    <mat-form-field appearance="outline" subscriptSizing="dynamic">
                        <mat-label>Company Name</mat-label>
                        <input matInput [(ngModel)]="data.companyName" placeholder="Your Company Name">
                    </mat-form-field>

                    <mat-form-field appearance="outline" subscriptSizing="dynamic">
                        <mat-label>Phone</mat-label>
                        <input matInput [(ngModel)]="data.phoneNumber" placeholder="Phone Number">
                    </mat-form-field>

                    <mat-form-field appearance="outline" subscriptSizing="dynamic">
                        <mat-label>Company Details / Address</mat-label>
                        <textarea matInput [(ngModel)]="data.companyDetails" rows="3"
                            placeholder="Address, VAT, etc."></textarea>
                    </mat-form-field>

                    <div class="info-note" style="font-size: 11px; color: #666; margin-top: 5px;">
                        <mat-icon
                            style="font-size: 12px; height: 12px; width: 12px; vertical-align: middle;">info</mat-icon>
                        These changes will update your main profile.
                    </div>
                </div>

                <!-- CUSTOMER Details - Static Preview -->
                <div class="address-block static-preview">
                    <h3>Customer</h3>
                    <p><strong>[Customer Name]</strong></p>
                    <p>[Customer Phone]</p>
                    <p>[Customer Email]</p>
                    <p><em>(This section will be auto-filled from booking)</em></p>
                </div>
            </div>

            <!-- Booking Details - Static Preview -->
            <div class="details-section">
                <h3>Time Sheet Details (Preview)</h3>
                <table class="lpo-table">
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th>Start Time</th>
                            <th>End Time</th>
                            <th>Total Hours</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>[Date]</td>
                            <td>[Start Time]</td>
                            <td>[End Time]</td>
                            <td>[Hours]</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <!-- Terms & Conditions - Editable -->
            <div class="notes-section">
                <h3>Terms & Conditions</h3>
                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Terms & Conditions</mat-label>
                    <textarea matInput [(ngModel)]="data.terms" rows="6"
                        placeholder="Enter your standard terms and conditions here..."></textarea>
                </mat-form-field>
            </div>

            <!-- Footer / Signature - Editable -->
            <!-- <div class="footer-section">
                <mat-form-field appearance="outline" class="full-width" subscriptSizing="dynamic">
                    <mat-label>Footer Text (Optional)</mat-label>
                    <textarea matInput [(ngModel)]="data.footer" rows="2"
                        placeholder="e.g. Authorized Signatory"></textarea>
                </mat-form-field>
            </div> -->

            <div class="signature-section-wrapper">
                <h3>Authorized Signature</h3>

                <div class="signature-display" *ngIf="data.signatureBase64 || data.signatureUrl">
                    <img [src]="data.signatureBase64 || data.signatureUrl" alt="Signature">
                    <button mat-icon-button color="warn" (click)="data.signatureUrl = undefined; data.signatureBase64 = undefined">
                        <mat-icon>delete</mat-icon>
                    </button>
                </div>

                <div class="signature-controls" *ngIf="!data.signatureBase64 && !data.signatureUrl">
                    <mat-tab-group [(selectedIndex)]="selectedTabIndex" animationDuration="0ms">
                        <mat-tab label="Upload Image">
                            <div class="upload-tab">
                                <button mat-stroked-button color="primary" (click)="triggerSigInput()">
                                    <mat-icon>upload</mat-icon> Upload Signature Image
                                </button>
                                <input type="file" id="sigInputTs" (change)="onSigSelected($event)" accept="image/*"
                                    hidden>
                                <p class="hint">Upload a transparent PNG for best results.</p>
                            </div>
                        </mat-tab>
                        <mat-tab label="Draw Signature">
                            <div class="draw-tab">
                                <div class="canvas-wrapper">
                                    <canvas #sigCanvas width="400" height="150" (mousedown)="startDrawing($event)"
                                        (mousemove)="draw($event)" (mouseup)="stopDrawing()"
                                        (mouseleave)="stopDrawing()"></canvas>
                                </div>
                                <div class="canvas-actions">
                                    <button mat-button color="warn" (click)="clearCanvas()">Clear</button>
                                    <button mat-raised-button color="primary" (click)="saveCanvasSignature()">Use
                                        Signature</button>
                                </div>
                            </div>
                        </mat-tab>
                    </mat-tab-group>
                </div>
            </div>

        </div>
    </div>
</div>